import { AnimatedCircularProgress } from 'react-native-circular-progress';
import { CircularProgressProps } from './CircularProgressProps';

const CircularProgress = (props: CircularProgressProps) => {
  const state = {
    size: (props.radius || 0) * 2,
    width: props.activeStrokeWidth || 10,
    fill: props.value,
    tintColor: props.activeStrokeColor,
    backgroundColor: props.inActiveStrokeColor,
    rotation: props.rotation,
  };

  return (
    <AnimatedCircularProgress {...state}>
      {() => props.children as any}
    </AnimatedCircularProgress>
  );
};

export default CircularProgress;
